const initialState = {
  adminEarnings: {},
  totalWalletAmount: 0,
  totalFans: 0,
  totalAthletes: 0,
  blockedFans: 0,
  blockedAthletes: 0,
  totalIssues: 0,
  fanStatsData: {},
  boostEarnings: 0,
};

const DashboardReducers = (state = initialState, action) => {
  switch (action.type) {
    case "ADMIN_EARNINGS":
      return {
        ...state,
        adminEarnings: action.payload,
      };
    case "SET_TOTAL_WALLET_AMOUNT":
      return {
        ...state,
        totalWalletAmount: action.payload,
      };
    case "GET_ATHLETES_STATS":
      return {
        ...state,
        totalAthletes: action.payload.total_athletes,
        blockedAthletes: action.payload.blocked_athletes,
      };
    case "GET_FANS_STATS":
      return {
        ...state,
        totalFans: action.payload.total_fans,
        blockedFans: action.payload.blocked_fans,
        fanStatsData: action.payload,
      };
    case "GET_ISSUES_STATS":
      return {
        ...state,
        totalIssues: action.payload.total_issues,
      };
    case "SET_BOOST_EARNINGS":
      return {
        ...state,
        boostEarnings: action.payload,
      };

    default:
      return state;
  }
};

export default DashboardReducers;
